import { IconProps } from "./types";

export function LibraryIcon({ size = 24, className = "", ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <rect x="2" y="6" width="15" height="15" rx="2" ry="2" />
      <path d="M17 6V4a2 2 0 012-2h1a2 2 0 012 2v13a2 2 0 01-2 2h-1" />
      <circle cx="9.5" cy="13.5" r="3" />
    </svg>
  );
}
